var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "30px",
    viewBox: "0 0 31 29",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30A4\\u30F3\\u30BB\\u30F3\\u30C6\\u30A3\\u30D6",
    transform: "translate(-593.000000, -541.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(593.250000, 541.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F0396D",
    x: 0,
    y: 0,
    width: 30,
    height: 29,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "money-cny-circle-fill",
    transform: "translate(7.750000, 7.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 15 0 15 15 0 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,15 C3.35775,15 0,11.64225 0,7.5 C0,3.35775 3.35775,0 7.5,0 C11.64225,0 15,3.35775 15,7.5 C15,11.64225 11.64225,15 7.5,15 Z M8.25,8.25 L8.25,7.5 L10.5,7.5 L10.5,6 L8.5605,6 L10.152,4.40925 L9.09075,3.348 L7.5,4.9395 L5.90925,3.348 L4.848,4.41 L6.4395,6 L4.5,6 L4.5,7.5 L6.75,7.5 L6.75,8.25 L4.5,8.25 L4.5,9.75 L6.75,9.75 L6.75,11.25 L8.25,11.25 L8.25,9.75 L10.5,9.75 L10.5,8.25 L8.25,8.25 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.0e312522.svg";
export { ForwardRef as ReactComponent };